import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { makeStyles, AccordionSummary, GRAY } from '@applyboard/ui-components';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useIsMobile } from "../../../../../../../useIsMobile";
var useStyles = makeStyles({
  expandIcon: {
    width: '30px',
    height: '25px',
    color: GRAY[5]
  },
  MuiAccordionSummaryRoot: {
    '&.MuiAccordionSummary-root': {
      padding: 0,
      minHeight: '50px',
      bottom: '12px',
      '&.Mui-expanded': {
        minHeight: '50px'
      }
    }
  },
  MuiAccordionSummaryContent: {
    '&.MuiAccordionSummary-content.Mui-expanded': {
      margin: '12px 0'
    }
  },
  MuiAccordionSummaryIcon: {
    '&.MuiAccordionSummary-expandIcon': {
      order: function order(props) {
        return props.isMobile ? null : '-1';
      }
    }
  }
});
var StyledAccordionSummary = function StyledAccordionSummary(_ref) {
  var accepted = _ref.accepted,
    children = _ref.children;
  var isMobile = useIsMobile();
  var classes = useStyles({
    isMobile: isMobile
  });
  return /*#__PURE__*/React.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
      className: classes.expandIcon
    }),
    classes: {
      root: classes.MuiAccordionSummaryRoot,
      content: classes.MuiAccordionSummaryContent,
      expandIcon: classes.MuiAccordionSummaryIcon
    },
    style: {
      color: accepted ? undefined : GRAY[10]
    }
  }, children);
};
export default StyledAccordionSummary;